import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { ReduxRequestsMap } from "../../../shared/redux/redux-requests-map.service";

@Component({
    selector: "toggle-post-action",
    templateUrl: "./toggle-post-action.component.html",
})
export class TogglePostActionComponent {
    @Input() public stateProp: string;
    @Input() public fieldProp: string;
    @Input() public fieldValue: any;
    @Input() public onLabel: string;
    @Input() public offLabel: string;
    @Input() public detailId: number;
    @Input() @BooleanAttribute() public idIsArray = false;
    @Output() public postSuccess = new EventEmitter();

    constructor(private requestMap: ReduxRequestsMap) { }

    public toggleService(servicing): void {
        const payload: any = {
            [this.fieldProp]: !servicing,
        };

        if (this.idIsArray) {
            payload.ids = [this.detailId];
        } else {
            payload.id = this.detailId;
        }

        this.requestMap.within(this.stateProp).mutate(payload)
            .subscribe((res) => this.postSuccess.emit(true));
    }
}
